(function() {
    angular
        .module("app")
        .factory("trackersService", trackersService)

    trackersService.$inject = [
        "$rootScope",
        "$http",
        "queryStringService"
    ]

    function trackersService(
        $rootScope,
        $http,
        queryStringService
    ) {
        var service = {}

        /**
            Get single tracker
            @param {int}   trackerID
            @param {func?} successCallback
            @param {func?} failureCallback
         **/
        service.getTracker = function(trackerID, successCallback, failureCallback) {

            $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/trackers/" + trackerID
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    $rootScope.processDevice(response.data)
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        /**
            Create tracker
            @param {obj}   formData
            @param {func?} successCallback
            @param {func?} failureCallback
         **/
        service.createTracker = function(formData, successCallback, failureCallback) {

            var queryJson = queryStringService.createQueryJson(formData, "tracker")

            $http({
                method: "POST",
                url: $rootScope.config.apiUrl + "/trackers/",
                data: queryJson
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    $rootScope.processDevice(response.data)
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.editTracker = function(trackerID, formData, successCallback, failureCallback) {

            var queryJson = queryStringService.createQueryJson(formData, "tracker")

            $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/trackers/" + trackerID,
                data: queryJson
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    $rootScope.processDevice(response.data)
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error("Edit Tracker Failure: ", error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.editTrackerConnection = function(trackerID, formData, successCallback, failureCallback) {

            $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/trackers/" + trackerID + "/edit_connection",
                data: formData
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    $rootScope.processDevice(response.data)
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error("Edit Tracker Connection Failure: ", error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.setTrucksEnterRemoteOverride = function(trackerID, override, success, failure) {

            const _success = (response) => {
                if (success !== undefined) {
                    $rootScope.processDevice(response.data)
                    success(response.data)
                }
            }

            const _failure = (error) => {
                console.error("Set Trucks Enter Remote Override Failure: ", error)
                if (failure !== undefined) {
                    failure(error)
                }
            }

            $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/trackers/" + trackerID + "/trucks_enter/remote_override",
                data: {
                    remote_override: override
                }
            }).then(_success, _failure)
        }

        service.editTrucksEnterSettings = function(trackerID, formData, successCallback, failureCallback) {

            $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/trackers/" + trackerID + "/trucks_enter/update_settings",
                data: formData
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    $rootScope.processDevice(response.data)
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error("Edit Trucks Enter Settings Failure: ", error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.beaconTrailerSetBeaconOverride = function(trackerID, beacon_override, successCallback, failureCallback) {

            const success = (response) => {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
                return response.data
            }

            const failure = (error) => {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
                return error
            }

            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/trackers/" + trackerID + "/beacon_trailer/beacon_override",
                data: {
                    beacon_override: beacon_override
                }
            }).then(success, failure)
        }

        service.beaconTrailerEditSchedules = function(trackerID, newSchedules, successCallback, failureCallback) {

            const success = (response) => {
                if (successCallback !== undefined) {
                    $rootScope.processDevice(response.data)
                    successCallback(response.data)
                }
                return response.data
            }

            const failure = (error) => {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
                return error
            }

            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/trackers/" + trackerID + "/beacon_trailer/edit_schedules",
                data: newSchedules
            }).then(success, failure)
        }

        service.editMarkerSettings = function(trackerID, formData, successCallback, failureCallback) {

            const success = () => {
                if (successCallback !== undefined) {
                    successCallback()
                }
            }

            const failure = (error) => {
                console.error("Edit Marker Settings Failure: ", error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }

            $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/trackers/" + trackerID + "/marker/update_settings",
                data: formData
            }).then(success, failure)
        }

        service.editQwsSensorSettings = function(trackerID, formData, successCallback, failureCallback) {

            let url = $rootScope.config.apiUrl + "/trackers/" + trackerID + "/qws_sensor"

            url += "/update_settings"

            $http({
                method: "PUT",
                url:    url,
                data:   formData
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    $rootScope.processDevice(response.data)
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error("Edit QWS Sensor Settings Failure: ", error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.rebootController = function(trackerID, successCallback, failureCallback) {

            $http({
                method: "PUT",
                url:    $rootScope.config.apiUrl + "/trackers/" + trackerID + "/reboot_controller"
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    $rootScope.processDevice(response.data)
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error("Reboot Controller Failure: ", error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.setEnableAlerts = function(trackerID, enable, successCallback, failureCallback) {

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
                return response.data
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
                return error
            }

            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/trackers/" + trackerID + "/enable_alerts",
                data: {
                    enable_alerts: enable
                }
            }).then(success, failure)
        }

        /**
            @param {int}   trackerID
            @param {bool}  enable
            @param {func?} successCallback
            @param {func?} failureCallback
         **/
        service.setLiveTracking = function(trackerID, enable, successCallback, failureCallback) {

            function success(response) {

                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
                return response.data
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
                return error
            }

            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/trackers/" + trackerID + "/live_tracking",
                data: {
                    live_tracking: enable
                }
            }).then(success, failure)
        }

        /**
            Delete existing tracker
            @param {int}   trackerID
            @param {func?} successCallback
            @param {func?} failureCallback
         **/
        service.deleteTracker = function(trackerID, successCallback, failureCallback) {

            $http({
                method: "DELETE",
                url: $rootScope.config.apiUrl + "/trackers/" + trackerID
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error.data.errors[0])
                if (failureCallback !== undefined) {
                    failureCallback(error.data.errors[0])
                }
            }
        }

        /**
            @param {int}   trackerID
            @param {bool}  enable
            @param {func?} successCallback
            @param {func?} failureCallback
         **/
        service.arrowBoardSetDisplayState = function(trackerID, displayState, successCallback, failureCallback) {

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
                return response.data
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
                return error
            }

            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/trackers/" + trackerID + "/arrow_board/set_display",
                data: {
                    display_state: displayState
                }
            }).then(success, failure)
        }

        service.solarLightTowerSetLightLevels = function(trackerID, newLightLevels, successCallback, failureCallback) {

            const success = (response) => {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
                return response.data
            }

            const failure = (error) => {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
                return error
            }

            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/trackers/" + trackerID + "/solar_light_tower/set_light_levels",
                data: newLightLevels
            }).then(success, failure)
        }

        service.solarLightTowerRestoreLocal = (trackerID, successCallback, failureCallback) => {

            const success = (response) => {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
                return response.data
            }

            const failure = (error) => {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
                return error
            }

            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/trackers/" + trackerID + "/solar_light_tower/restore_local_control"
            }).then(success, failure)
        }

        service.solarLightTowerActivateDuskToDawn = (trackerID, successCallback, failureCallback) => {

            const success = (response) => {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
                return response.data
            }

            const failure = (error) => {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
                return error
            }

            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/trackers/" + trackerID + "/solar_light_tower/activate_dusk_to_dawn"
            }).then(success, failure)
        }

        service.setSystemVoltage = function(trackerID, systemVoltage, successCallback, failureCallback) {

            function success(response) {
                if (successCallback !== undefined) {
                    $rootScope.processDevice(response.data)
                    successCallback(response.data)
                }
                return response.data
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
                return error
            }

            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/trackers/" + trackerID + "/set_system_voltage",
                data: {
                    system_voltage: systemVoltage
                }
            }).then(success, failure)
        }

        service.setVoltageLimits = function(trackerID, warning, critical, successCallback, failureCallback) {

            function success(response) {
                if (successCallback !== undefined) {
                    $rootScope.processDevice(response.data)
                    successCallback(response.data)
                }
                return response.data
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
                return error
            }

            warning  = warning  === "" ? "0" : warning
            critical = critical === "" ? "0" : critical

            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/trackers/" + trackerID + "/set_voltage_limit",
                data: {
                    voltage_limit_warning:  warning,
                    voltage_limit_critical: critical
                }
            }).then(success, failure)
        }

        service.resetVehicleCounter = function(trackerID, successCallback, failureCallback) {

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
                return response.data
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
                return error
            }

            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/trackers/" + trackerID + "/trucks_enter/reset_counter"
            }).then(success, failure)
        }

        service.resetDisplayMinutes = function(trackerID, successCallback, failureCallback) {

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
                return response.data
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
                return error
            }

            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/trackers/" + trackerID + "/arrow_board/reset_display_active_minutes"
            }).then(success, failure)
        }

        service.resetDisplayMinutesBoth = function(trackerID, successCallback, failureCallback) {

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
                return response.data
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
                return error
            }

            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/trackers/" + trackerID + "/arrow_board/reset_display_active_minutes_both"
            }).then(success, failure)
        }

        return service
    }
})()
